export class ApiEndPointsContact {
    getContactListing = 'api/Contact/GetContacts';
    getFavoriteContactListing = 'api/ContactFavorite/GetFavoriteContacts';
    getContactFeildList = 'api/Core/GetAllFolderFields';
    saveContactFieldList = 'api/Contact/AddContact';
    saveContactUserDetails = 'api/Contact/UpdateContact';
    getContactUserDetails = 'api/Contact/GetContactDetail';
    getContactFieldColumn = 'api/CustomizedGridComponent/GetUserGridCustomizedSetting';
    updateContactFieldColumn = 'api/CustomizedGridComponent/UpdateUserGridCustomizationSetting';
    ReorderContactFieldColumn = 'api/CustomizedGridComponent/ReorderColumn';
    getImageUploadURL = 'api/App/UploadProfilePic';

    getDefaultFilterFieldsList = 'api/Filter/GetDefaultFilterFields';
    CreateFilter = 'api/Filter/AddFillter';
    GetAllFillters = 'api/Filter/GetAllFillters';
    GetFilteredContacts = 'api/Contact/GetFilteredContacts';
    DeleteContactTransaction = 'api/Contact/DeleteContact';
    FavoriteContactTransaction = 'api/ContactFavorite/AddContactFavorite';
    FavoriteDeleteContactTransaction = 'api/ContactFavorite/DeleteContactFavorite';
    searchTransCities = 'api/app/SearchCities';
    searchTransZip = 'api/app/SearchZipCode';
    getStateList = 'api/Orgnization/GetStateValues';
    RenameProjectName = 'api/Project/RenameProjectName';
    MakeFilterFavorite = 'api/Filter/MakeFilterDefault';
    getContactRecentFilter = 'api/Filter/RecentFilter';
    GetUserPreferences = 'api/Auth/GetUserPreferences';
    AddPrefrences = 'api/Auth/AddPreferences';
    RemoveSelectedFilter = 'api/Filter/DeleteFillters';
    setContactArchive = "api/Contact/SetContactArchive";
    setContactActivate = "api/Contact/SetContactActivate";
    addUserKanbanView = "api/Core/AddUserKanbanView";
    changeContactStatus = "api/Contact/ChangeContactStatus";
    getHtmlFormData="api/Project/GetHtmlFormData";
    addWebFormUserSetting="api/Project/AddWebFormUserSetting";
}
